module.exports = __webpack_public_path__ + "ge.add0d07d0a9139f96f57.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/ge.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/ge.svg
// module chunks = styles